// The Team surface's directory transport — the routed proposals and the DIRECT contact commits
// (BUILD-DEC-127). Split out of `api-client.ts` to hold that file's size ceiling; same posture as
// every other leg: same-origin only, no Actor/role field on the wire (the server resolves the Actor),
// a mutation is never retried, and a refusal comes back as a sanitised user-facing note (G-197).

import { postIntent, API_PREFIX } from './post-intent.ts';
import type { SurfaceApi } from './api-client.ts';

const DIRECTORY_PROPOSE_PATH = `${API_PREFIX}/team/directory-propose`;
const DIRECTORY_ACTION_PATH = `${API_PREFIX}/team/directory-action`;
const CONTACT_ACTION_PATH = `${API_PREFIX}/team/contact-action`;

/** The directory legs: the propose/resolve routes and the DIRECT contact commits (BUILD-DEC-127). */
export function httpDirectoryRoutes(): Pick<
  SurfaceApi,
  'routeDirectoryPropose' | 'routeDirectoryResolve' | 'routeContactAction'
> {
  return {
    routeDirectoryPropose: (changeKind, summary, targetUserId) =>
      postIntent(
        DIRECTORY_PROPOSE_PATH,
        targetUserId !== undefined
          ? { changeKind, summary, targetUserId }
          : { changeKind, summary },
      ),
    routeDirectoryResolve: (proposalId, decision) =>
      postIntent(DIRECTORY_ACTION_PATH, { proposalId, decision }),
    routeContactAction: (intent) => postIntent(CONTACT_ACTION_PATH, { ...intent }),
  };
}
